export const apiMessages: Record<string, string> = {
  "VALIDATION_ERROR": "輸入資料不正確，請檢查欄位格式與數值。",
  "MALFORMED_REQUEST": "送出的資料格式不正確，請重新輸入。",
  "AUTH_INVALID_CREDENTIALS": "帳號、電子郵件或密碼不正確。",
  "AUTH_INVALID_TOKEN": "登入已失效，請重新登入。",
  "USER_DISABLED": "此帳號已停用，請聯絡客服。",
  "USER_ALREADY_EXISTS": "帳號或電子郵件已被使用。",
  "USER_NOT_FOUND": "找不到此使用者。",
  "SYMBOL_NOT_FOUND": "找不到此交易標的，請重新選擇。",
  "SIMULATION_RULE_INVALID": "行情設定不正確，請檢查目標價格、波動幅度與時間。",
  "SYMBOL_NOT_TRADABLE": "此標的目前暫停交易。",
  "MARKET_CLOSED": "此標的目前已休市，請於開市後再下單。",
  "TRADING_PAUSED": "此標的暫停下單，請稍後再試。",
  "MARKET_PRICE_UNAVAILABLE": "目前無法取得有效行情，請稍後再試。",
  "INVALID_ORDER_QUANTITY": "交易數量不正確，請檢查最低數量與小數位數。",
  "ORDER_AMOUNT_TOO_SMALL": "交易金額低於此標的的最低委託金額。",
  "INSUFFICIENT_BALANCE": "可用餘額不足，請減少金額或數量。總資產中的持倉與凍結款項無法直接用於買入或出金。",
  "INSUFFICIENT_POSITION": "可賣數量不足，請確認目前持倉數量。",
  "ORDER_NOT_FOUND": "找不到此訂單。",
  "POSITION_NOT_FOUND": "找不到此持倉。",
  "FORBIDDEN": "您沒有執行此操作的權限。",
  "NOT_FOUND": "找不到所需資料。",
  "DATA_CONFLICT": "資料已變更或請求重複，請重新整理後再試。",
  "INTERNAL_ERROR": "系統暫時無法完成操作，請稍後再試。",
  "NETWORK_ERROR": "無法連線至伺服器，請檢查網路後重試。",
  "ERR_NETWORK": "無法連線至伺服器，請檢查網路後重試。",
  "ECONNABORTED": "連線逾時，請稍後重試同一筆操作。"
}

export function localizedError(code: string, message?: string): string {
  if (message && /[\u3400-\u9fff]/.test(message)) return message
  return apiMessages[code] ?? "操作未完成，請稍後重試。"
}
